
// This is a test layout
// TODO remove this
export default {
  name: 'TestLayout',
  mounted() {
    console.debug('Test layout mounted');
  },
};
